import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Button, Collapse, Stack } from '@mui/material';
import React, { useId, useState } from 'react';

export const CollapsibleSection = ({ title, children }: { title: string; children: React.ReactNode }) => {
  const [expanded, setExpanded] = useState(false);
  const contentId = useId();
  return (
    <Stack spacing={1} sx={{ minWidth: 0 }}>
      <Button
        color="inherit"
        variant="text"
        size="small"
        aria-expanded={expanded}
        aria-controls={contentId}
        startIcon={
          <ExpandMoreIcon
            sx={{
              transform: expanded ? 'rotate(180deg)' : 'none',
              transition: (theme) => theme.transitions.create('transform'),
            }}
          />
        }
        sx={{ alignSelf: 'flex-start', textTransform: 'none' }}
        onClick={() => setExpanded((current) => !current)}
      >
        {title}
      </Button>
      <Collapse id={contentId} in={expanded} timeout="auto">
        {children}
      </Collapse>
    </Stack>
  );
};
